<template>
  <div class="sw-filter-bar">
    <v-menu
      v-if="hasFilterFields"
      v-model="panelOpen"
      location="bottom start"
      :close-on-content-click="false"
      transition="tickets-action-menu-transition"
      content-class="tickets-action-menu__overlay"
      :offset="6"
    >
      <template #activator="{ props: menuProps }">
        <button
          type="button"
          class="sw-filter-bar__filters-btn"
          :aria-expanded="panelOpen"
          aria-haspopup="dialog"
          v-bind="menuProps"
        >
          <v-icon size="18" class="sw-filter-bar__filters-icon">
            mdi-filter-variant
          </v-icon>
          <span class="sw-filter-bar__filters-label">Filters</span>
          <span
            v-if="displayBadgeCount > 0"
            class="sw-filter-bar__badge"
            aria-label="Active filters"
          >
            {{ displayBadgeCount }}
          </span>
        </button>
      </template>

      <SwFilterDrawer @close="panelOpen = false">
        <slot />
      </SwFilterDrawer>
    </v-menu>

    <div class="sw-filter-bar__search">
      <slot name="search">
        <SwSearchField
          :model-value="search"
          :label="searchLabel"
          :placeholder="searchPlaceholder"
          clearable
          v-bind="mergedSearchAttrs"
          @update:model-value="$emit('update:search', $event)"
          @clear="onInnerClear"
          @search="onInnerSearch"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import SwSearchField from "./SwSearchField.vue";
import SwFilterDrawer from "./SwFilterDrawer.vue";
import { getFilterBadgeCount } from "@/utils/pageFilterCount.js";

export default {
  name: "SwFilterBar",
  components: { SwSearchField, SwFilterDrawer },
  inheritAttrs: false,
  props: {
    search: { type: String, default: "" },
    searchLabel: { type: String, default: "Search" },
    searchPlaceholder: { type: String, default: "Search..." },
    activeFilterCount: { type: Number, default: 0 },
    searchAttrs: { type: Object, default: () => ({}) },
  },
  emits: ["update:search", "search", "clear"],
  data() {
    return {
      panelOpen: false,
    };
  },
  computed: {
    hasFilterFields() {
      return !!this.$slots.default;
    },
    badgeCount() {
      return Number(this.activeFilterCount) || 0;
    },
    displayBadgeCount() {
      return getFilterBadgeCount(this.badgeCount);
    },
    /** Strip listeners handled by SwFilterBar so Enter/icon don't double-fire. */
    mergedSearchAttrs() {
      const merged = { ...this.searchAttrs, ...this.$attrs };
      const {
        onKeyupEnter,
        onSearch,
        onClear,
        ...rest
      } = merged;
      return rest;
    },
  },
  methods: {
    onInnerSearch(value) {
      this.$emit("search", value);
      // Back-compat for pages that only wire @keyup.enter (not @search)
      if (typeof this.$attrs.onSearch === "function") return;
      const keyupHandler =
        this.$attrs.onKeyupEnter || this.searchAttrs?.onKeyupEnter;
      if (typeof keyupHandler === "function") {
        keyupHandler();
      }
    },
    onInnerClear() {
      this.$emit("clear");
    },
  },
};
</script>
